import { render } from "./AposInputColor.vue?vue&type=template&id=1aa41567&scoped=true"
import script from "./AposInputColor.vue?vue&type=script&lang=js"
export * from "./AposInputColor.vue?vue&type=script&lang=js"

import "./AposInputColor.vue?vue&type=style&index=0&id=1aa41567&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aa41567"],['__file',"color-field/ui/apos/components/AposInputColor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1aa41567"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1aa41567', __exports__)) {
    api.reload('1aa41567', __exports__)
  }
  
  module.hot.accept("./AposInputColor.vue?vue&type=template&id=1aa41567&scoped=true", () => {
    api.rerender('1aa41567', render)
  })

}


export default __exports__